module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "ksm-navbar"
  }, [_vm._l((_vm.navList), function(it, i) {
    return [_c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (it.disable ? _vm.tooltipOption : ''),
        expression: "it.disable?tooltipOption:''"
      }],
      key: i,
      staticClass: "ksm-navitem ksm-link-text",
      class: {
        active: it.names.indexOf(_vm.routeName) > -1,
        disable: it.disable
      },
      on: {
        "click": function($event) {
          return _vm.toPage(it)
        }
      }
    }, [_vm._v(_vm._s(it.label))])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da0e75e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Nav.vue
// module id = 1974
// module chunks = 1